import React, { useState, useEffect } from "react"
import _ from "lodash"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap"
import PropTypes from 'prop-types'

const ModalComponent = (props) => {

    let { toggle, isOpen, size, title, footerBtns, children, isSaving } = props

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            size={size | 'sm'}
        >
            {/* header */}
            <div className="modal-header border-0 px-0 mx-0">
                <Row>
                    <Col md='1'/>
                    <Col>
                        <h5 className="modal-title" id="myModalLabel">
                            {title}
                        </h5>
                    </Col>
                    <Col md='1' className='mr-3'>
                        <button
                            aria-hidden={true}
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={toggle}
                        >
                            <i className="nc-icon nc-simple-remove" />
                        </button>
                    </Col>
                </Row>

            </div>

            {/* body (with scroll) */}
            <ModalBody className='p-0 m-0' /*style={{ 'maxHeight': 'calc(100vh - 250px)', 'overflowY': 'auto' }}*/>
                {children}
            </ModalBody>

            {/* footer */}
            {/*{footerBtns && (
                <div className="modal-footer border-0 justify-content-center mr-3">
                    <hr />
                    {_.map(footerBtns, (btn, key) => (
                        <Button
                            key={key}
                            onClick={btn.onClick}
                            className={btn.className}
                            color='info'
                        >{btn.title}</Button>
                    ))}
                </div>
            )}*/}

            {footerBtns && (
                <ModalFooter className='px-3'>
                    {_.map(footerBtns, (btn, key) => (
                        <Button color="success" disabled={isSaving} onClick={btn.onClick}>
                            {isSaving ? 'Loading ...' : (btn.title ?? 'Save')}
                        </Button>
                    ))}

                </ModalFooter>
            )}


        </Modal>

    )

}

export default ModalComponent

ModalComponent.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    title: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    footerBtns: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        className: PropTypes.string,
        onClick: PropTypes.func.isRequired
    })),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

ModalComponent.defaultProps = {
    size: 'sm'
}
